import React, { useCallback } from 'react';
import { Button } from 'js/components/common/Button';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { useDispatch } from 'react-redux';

import { showTicketDetailsPopupAction } from '../TicketDetailsPopup';

export const TicketCell = ({ name, row }) => {
    const dispatch = useDispatch();
    const t = useComponentTranslations();

    const open = useCallback(() => dispatch(showTicketDetailsPopupAction({
        transaction: row,
        t
    })), [
        t,
        row,
        dispatch
    ]);

    return (
        <Button onClick={open} size="small">
            {t(`table.cell.link.${name}`)}
        </Button>
    );
};
